import { render } from "./ProductMasterList.vue?vue&type=template&id=b028ef52&scoped=true"
import script from "./ProductMasterList.vue?vue&type=script&lang=js"
export * from "./ProductMasterList.vue?vue&type=script&lang=js"

import "./ProductMasterList.vue?vue&type=style&index=0&id=b028ef52&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b028ef52"]])

export default __exports__